/**
 *
 * Promo Banner
 *
 * UI for handling some fun events for promo banner
 *
 * Date: 18/03/2020
 * Dev: Mirza Masic
 *
 */

const $      = require( 'jQuery' );

var PromoBanner = function(el){
  this.$el            = $(el);
  this.$closeCircle   = this.$el.find( '.itbl-c-promo__circle-close' );
  this.$closeTextline = this.$el.find( '.itbl-c-promo__textline-close' );

  this.init();
};

PromoBanner.prototype.init = function(){
  //events
  this.$closeCircle.on( 'click', this.event__hideBanner.bind(this) );
  this.$closeTextline.on( 'click', this.event__hideBanner.bind(this) );

  this.event__addHideClass();
};

PromoBanner.prototype.event__hideBanner = function( event ){

  event.preventDefault();

  $('body').removeClass('promo-block-visible');
  this.$el.addClass( 'bounce-out-left' );

  sessionStorage.setItem('itbl_promo_banner_hidden', 1);

  const positionBreadcrumbsEvent  = new CustomEvent('positionBreadcrumbs', {
    bubbles: true,
  });

  window.dispatchEvent(positionBreadcrumbsEvent);

  $('body #content').css({'margin-top': '-25px', 'padding-top': '0'});
};

PromoBanner.prototype.event__addHideClass = function() {
  
  if(sessionStorage.getItem('itbl_promo_banner_hidden')) {
    $('body').removeClass('promo-block-visible');
    this.$el.addClass( 'hidden' );
  }
  else {
    $('body').addClass('promo-block-visible');
    this.$el.addClass( 'shown' );
  }

}

$(document).ready(function(){
  $('.itbl-c-promo').each(function(){
    new PromoBanner(this);
  });
});
